<template>
  <div class="content">
    <header-top></header-top>
    <div class="tableBox">
      <el-table :data="list" border style="width: 100%;">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column label="标题">
          <template slot-scope="scope">
            <span @click="toInfo(scope.row.id)" class="title">{{scope.row.title}}</span>
          </template>
        </el-table-column>
        <el-table-column label="发布时间">
          <template slot-scope="scope">
            {{scope.row.created_at | dateFormat}}
          </template>
        </el-table-column>
      </el-table>

        <!-- 分页 -->
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="listTotal"
        prev-text="上一页"
        next-text="下一页"
        class="page"
      ></el-pagination>
    </div>
    <foot></foot>
  </div>
</template>

<script>
import foot from "@/components/footer.vue";
import headerTop from "@/components/header.vue";
import {index} from "@/api/common.js";

export default {
  components: {
    foot,
    headerTop
  },
  filters:{},
  data() {
    return {
      list: [],
      currentPage: 1,
      pageSize: 10,
      listTotal: 0
    };
  },
  created(){
    this.getList();
  },
  methods: {
    toInfo(id) {
      this.$router.push({
        path: `/message/notice/${id}`
      });
    },
    //获取公告列表
    getList() {
      const offset = (this.currentPage - 1) * this.pageSize;
      let payload = {
        offset,
        limit: this.pageSize
      };
      index('urgentnoticeMaps',payload).then(res => {
        this.list = res.data.rows;
        this.listTotal = res.data.count;
      })
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getNoticeList();
    }
  }
};
</script>

<style lang="scss" scoped>
.tableBox {
  width: 700px;
  margin: 50px auto;
}
.title {
  cursor: pointer;
}
.page {
  margin-top: 30px;
}
@media screen and (min-width: 320px) and (max-width: 980px) {
  .tableBox {
    width: 100%;
    margin: 20px 0;
    padding: 0 10px;
    box-sizing: border-box;
  }
}

</style>

<style>
.el-table td,
.el-table th {
  text-align: center;
}
</style>


